export const LOCAL_STORAGE_SET = 'LOCAL_STORAGE_SET';

export const setLocalStorageValue = (key, value) => ({
    type: LOCAL_STORAGE_SET,
    key,
    value
});
